import { useState, useRef, useEffect } from "react";
import { EventName, getEventTypeLabel, getEventIconClass } from "./eventDescription";
import "./eventModal.sass";

export default function EventModal({ event, side = "home" }) {
  const [isHovering, setIsHovering] = useState(false);
  const [modalStyle, setModalStyle] = useState({});
  const wrapperRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isHovering && modalRef.current && wrapperRef.current) {
      const modal = modalRef.current;
      const modalRect = modal.getBoundingClientRect();
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      
      // Calcular overflow
      const leftOverflow = modalRect.left;
      const rightOverflow = modalRect.right - window.innerWidth;
      
      let newStyle = {};
      
      // Si sobresale a la derecha
      if (rightOverflow > 10) {
        newStyle = { left: "auto", right: "0", transform: "none" };
      } 
      // Si sobresale a la izquierda
      else if (leftOverflow < 10) {
        newStyle = { left: "0", transform: "none" };
      }
      // Normal (centrado)
      else {
        newStyle = { left: "50%", transform: "translateX(-50%)" };
      }
      
      setModalStyle(newStyle);
    }
  }, [isHovering]);

  return (
    <div
      ref={wrapperRef}
      className={`event-modal-wrapper event-modal-wrapper--${side}`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Ícono del evento */}
      <div className={`event-modal-icon ${getEventIconClass(event)}`}></div>

      {/* Modal/Tooltip que aparece en hover */}
      {isHovering && (
        <div
          ref={modalRef}
          className={`event-modal event-modal--${side}`}
          style={modalStyle}
        >
          <div className="event-modal-header">
            <span className="event-modal-type">{getEventTypeLabel(event)}</span>
            <span className="event-modal-time">{event.timeMin}'</span>
          </div>

          <div className="event-modal-content">
            <div className="event-modal-player">
              <span className="event-modal-label">Jugador:</span>
              <span className="event-modal-value">{EventName(event)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}